import Tabs from '../../core/Tabs/Tabs'
import GeneralPreferences from '../../domain/GeneralPreferences/GeneralPreferences'
import NotificationsPreferences from '../../domain/NotificationsPreferences/NotificationsPreferences'

export const Preferences = ({}) => {
    const tabs = [
        {
            name: 'general',
            label: 'General',
            Component: GeneralPreferences
        },
        {
            name: 'notifications',
            label: 'Notifications',
            Component: NotificationsPreferences
        }
    ]

    return (
        <div className="container-fluid">
            {tabs.length && (
                <div className="row justify-content-center">
                    <Tabs tabs={tabs} />
                </div>
            )}
        </div>
    )
}

export default Preferences